<template>
  <div>
    <section class="dashboard">
      <div>
        <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
        <!-- <loading :active.sync="isLoading" loader="spinner" color="#36304a" :width="70"></loading> -->
      </div>

      <b-card class="mainCardBG">
        <!-- <b-breadcrumb>
          <b-breadcrumb-item>
             <md-icon icon="house-fill" scale="1.25" shift-v="1.25" aria-hidden="true"></md-icon>
            Analytics 
          </b-breadcrumb-item>
        </b-breadcrumb>-->
        <!-- <date-picker
          v-model="value1"
          type="date"
          :lang="langType"
          range
          range-separator="-"
          placeholder="Select date range"
        ></date-picker>-->
        <b-navbar-nav>
          <b-button
            @click="previousPage"
            class="mt-2"
            size="sm"
            variant="light"
          >
            <md-icon icon="gear-fill" aria-hidden="true">skip_previous</md-icon
            >Back
          </b-button>
        </b-navbar-nav>
        <b-navbar toggleable="lg" type="dark" variant="info">
          <b-navbar-brand>
            <h3>{{ clientName }}</h3>
          </b-navbar-brand>
          <span class="text-muted">{{ companyType }}</span>
          <!-- <b-button-group size="sm" class="mt-3 ml-1">
            
            <b-button variant="outline-info" @click="dashboardReports">Reporting</b-button>
          </b-button-group>-->
          <!-- Right aligned nav items -->
          <b-navbar-nav class="ml-auto">
            <b-nav-form>
              <date-range-picker
                :opens="openLeft"
                :always-show-calendars="showCal"
                v-model="dateRange"
                :startDate="startDate"
                :endDate="endDate"
                :locale-data="locale"
                @update="getData"
              >
                <!--Optional scope for the input displaying the dates -->
                <!-- <div slot="input" slot-scope="picker">{{ picker.startDate }} - {{ picker.endDate }}</div> -->
              </date-range-picker>
            </b-nav-form>
          </b-navbar-nav>
        </b-navbar>

        <div class="gutr mt-4">
          <div class="row">
            <div class="col-xl-2 col-sm-6 grid-margin stretch-card">
              <div class="card card-statistics">
                <div class="card-body">
                  <div class="d-flex justify-content-between flex-wrap">
                    <div>
                      <h5 class="card-title">Enquiry</h5>
                      <div class="fluid-container">
                        <h4 class="card-title font-weight-bold mb-0">
                          {{ totalEnq }}
                        </h4>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-xl-3 col-sm-6 grid-margin stretch-card">
              <div class="card card-statistics">
                <div class="card-body">
                  <div class="d-flex justify-content-between flex-wrap">
                    <div>
                      <h5 class="card-title">Total Executions</h5>
                      <div class="fluid-container">
                        <h4 class="card-title font-weight-bold mb-0">
                          {{ totalExec }}
                        </h4>
                        <div class="row mt-1">
                          <span style="margin: 0px" class="text-muted ml-3 mr-2"
                            >FF-{{ totalFF }},</span
                          >
                          <span class="text-muted mr-2">CC-{{ totalCC }},</span>
                          <span class="text-muted">TPT-{{ totalTPT }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-xl-3 col-sm-6 grid-margin stretch-card">
              <div class="card card-statistics">
                <div class="card-body">
                  <div class="d-flex justify-content-between flex-wrap">
                    <div>
                      <h5 class="card-title">Container Shipped</h5>
                      <div class="fluid-container">
                        <h4 class="card-title font-weight-bold mb-0">
                          {{ totalContainerShiped }}
                        </h4>
                        <!-- <p
                          style="margin:0px"
                          class="text-muted mt-1"
                        >Export {{containerShipedExport}}</p>
                        <p class="text-muted">Import {{containerShipedImport}}</p>-->
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-4 grid-margin stretch-card">
              <b-card style="height: 220px">
                <b-card-text>
                  <div>
                    <h5 class="card-title mt-3">Executions By Modules</h5>
                    <div class="fluid-container">
                      <!-- <h5 class="card-title font-weight-bold mb-0">{{totalExec}}</h5> -->
                    </div>
                  </div>
                  <div id="chart">
                    <apexchart
                      style="margin-left: -35px"
                      v-if="showgraphsAir == true"
                      type="pie"
                      width="350"
                      :options="chartOptions"
                      :series="series"
                    ></apexchart>
                  </div>
                </b-card-text>
              </b-card>
            </div>
          </div>
        </div>

        <div class="row gutr">
          <div class="col-xl-3 col-sm-6 grid-margin stretch-card">
            <div class="card card-statistics">
              <div class="card-body">
                <div class="d-flex justify-content-between flex-wrap">
                  <div>
                    <h5 class="card-title">Freight Revenue</h5>
                    <div class="fluid-container">
                      <div class="row">
                        <p
                          class="card-title text-muted font-weight-bold mb-0 ml-3 mr-1"
                        >
                          {{ FFfinalAmountINR }} ,
                        </p>
                        <p
                          class="card-title text-muted font-weight-bold mb-0 mr-1"
                        >
                          {{ FFfinalAmountUSD }} ,
                        </p>
                        <p class="card-title text-muted font-weight-bold mb-0">
                          {{ FFfinalAmountEURO }}
                        </p>
                      </div>
                      <div class="row">
                        <p
                          class="card-title text-muted font-weight-bold mb-0 ml-3 mr-1"
                        >
                          {{ FFfinalAmountAED }}
                        </p>
                        <p
                          class="card-title text-muted font-weight-bold mb-0 mr-1"
                        >
                          {{ FFfinalAmountGBP }}
                        </p>
                        <p class="card-title text-muted font-weight-bold mb-0">
                          {{ FFfinalAmountZAR }}
                        </p>
                      </div>
                      <div class="row">
                        <p
                          class="card-title text-muted font-weight-bold mb-0 ml-3 mr-1"
                        >
                          {{ FFfinalAmountCAD }}
                        </p>
                        <p class="card-title text-muted font-weight-bold mb-0">
                          {{ FFfinalAmountJOD }}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-xl-3 col-sm-6 grid-margin stretch-card">
            <div class="card card-statistics">
              <div class="card-body">
                <div class="d-flex justify-content-between flex-wrap">
                  <div>
                    <h5 class="card-title">Custom Revenue</h5>
                    <div class="fluid-container">
                      <h4 class="card-title font-weight-bold mb-0">
                        {{ CustomRevenue }}
                      </h4>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-xl-3 col-sm-6 grid-margin stretch-card">
            <div class="card card-statistics">
              <div class="card-body">
                <div class="d-flex justify-content-between flex-wrap">
                  <div>
                    <h5 class="card-title">Transport Revenue</h5>
                    <div class="fluid-container">
                      <h4 class="card-title font-weight-bold mb-0">
                        {{ TPTRevenue }}
                      </h4>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-xl-3 col-sm-6 grid-margin stretch-card">
            <div class="card card-statistics">
              <div class="card-body">
                <div class="d-flex justify-content-between flex-wrap">
                  <div>
                    <h5 class="card-title">Total Revenue</h5>

                    <div class="fluid-container">
                      <h4 class="card-title font-weight-bold mb-0">
                        <h4>&#8377; {{ totalRevenueDefaultINR }}</h4>
                      </h4>
                    </div>
                    <b-button
                      style="
                        padding: 0.5rem 0.5rem;
                        font-size: 0.7rem;
                        line-height: 1;
                        border-radius: 0rem;
                        margin-right: 0px;
                      "
                      size="sm"
                      variant="light"
                      v-b-toggle.collapse-1
                      >Calculate</b-button
                    >
                    <b-collapse id="collapse-1" class="mt-2">
                      <div class="fluid-container mt-2">
                        <!-- <div class="row">
                        <b-form-input :formatter="capitalizeAll"
                          disabled
                          class="pull-right ml-3"
                          style="width: 155px;padding: 10px;border:none;    background: #fff;border-radius: 0rem"
                          id="distance"
                          name="distance"
                          type="number"
                        ></b-form-input>
                        <h6 class="card-title font-weight-bold mb-0 ml-2">
                          <small>{{finalAmountINR}}</small>
                        </h6>
                        </div>-->
                        <div class="row mt-2">
                          <b-button
                            class="pull-right ml-3 ml-3"
                            style="
                              padding: 0.5rem 0.5rem;
                              font-size: 0.7rem;
                              line-height: 1;
                              border-radius: 0rem;
                              margin-right: 0px;
                            "
                            size="sm"
                            variant="light"
                            @click="getData"
                            >Calculate</b-button
                          >
                          <b-form-input
                            :formatter="capitalizeAll"
                            class="pull-right"
                            style="
                              width: 90px;
                              padding: 10px;
                              background: #f8f9fa;
                              border-radius: 0rem;
                            "
                            v-model="USDRates"
                            id="distance"
                            name="distance"
                            type="number"
                          ></b-form-input>

                          <h6
                            class="card-title font-weight-bold mb-0 mt-1 ml-2"
                          >
                            <small>{{ finalAmountUSD }}</small>
                          </h6>
                        </div>
                        <div class="row mt-2">
                          <b-button
                            class="pull-right ml-3"
                            style="
                              padding: 0.5rem 0.5rem;
                              font-size: 0.7rem;
                              line-height: 1;
                              border-radius: 0rem;
                              margin-right: 0px;
                            "
                            size="sm"
                            variant="light"
                            @click="getData"
                            >Calculate</b-button
                          >
                          <b-form-input
                            :formatter="capitalizeAll"
                            class="pull-right"
                            style="
                              width: 90px;
                              padding: 10px;
                              background: #f8f9fa;
                              border-radius: 0rem;
                            "
                            v-model="EURORates"
                            id="distance"
                            name="distance"
                            type="number"
                          ></b-form-input>

                          <h6
                            class="card-title font-weight-bold mb-0 ml-2 mt-1"
                          >
                            <small>{{ finalAmountEURO }}</small>
                          </h6>
                        </div>
                        <div class="row mt-2">
                          <b-button
                            class="pull-right ml-3"
                            style="
                              padding: 0.5rem 0.5rem;
                              font-size: 0.7rem;
                              line-height: 1;
                              border-radius: 0rem;
                              margin-right: 0px;
                            "
                            size="sm"
                            variant="light"
                            @click="getData"
                            >Calculate</b-button
                          >
                          <b-form-input
                            :formatter="capitalizeAll"
                            class="pull-right"
                            style="
                              width: 90px;
                              padding: 10px;
                              background: #f8f9fa;
                              border-radius: 0rem;
                            "
                            v-model="ZARRates"
                            id="distance"
                            name="distance"
                            type="number"
                          ></b-form-input>

                          <h6
                            class="card-title font-weight-bold mb-0 ml-2 mt-1"
                          >
                            <small>{{ finalAmountZAR }}</small>
                          </h6>
                        </div>
                        <div class="row mt-2">
                          <b-button
                            class="pull-right ml-3"
                            style="
                              padding: 0.5rem 0.5rem;
                              font-size: 0.7rem;
                              line-height: 1;
                              border-radius: 0rem;
                              margin-right: 0px;
                            "
                            size="sm"
                            variant="light"
                            @click="getData"
                            >Calculate</b-button
                          >
                          <b-form-input
                            :formatter="capitalizeAll"
                            class="pull-right"
                            style="
                              width: 90px;
                              padding: 10px;
                              background: #f8f9fa;
                              border-radius: 0rem;
                            "
                            v-model="CADRates"
                            id="distance"
                            name="distance"
                            type="number"
                          ></b-form-input>

                          <h6
                            class="card-title font-weight-bold mb-0 ml-2 mt-1"
                          >
                            <small>{{ finalAmountCAD }}</small>
                          </h6>
                        </div>
                        <div class="row mt-2">
                          <b-button
                            class="pull-right ml-3"
                            style="
                              padding: 0.5rem 0.5rem;
                              font-size: 0.7rem;
                              line-height: 1;
                              border-radius: 0rem;
                              margin-right: 0px;
                            "
                            size="sm"
                            variant="light"
                            @click="getData"
                            >Calculate</b-button
                          >
                          <b-form-input
                            :formatter="capitalizeAll"
                            class="pull-right"
                            style="
                              width: 90px;
                              padding: 10px;
                              background: #f8f9fa;
                              border-radius: 0rem;
                            "
                            v-model="GBPRates"
                            id="distance"
                            name="distance"
                            type="number"
                          ></b-form-input>

                          <h6
                            class="card-title font-weight-bold mb-0 ml-2 mt-1"
                          >
                            <small>{{ finalAmountGBP }}</small>
                          </h6>
                        </div>
                        <div class="row mt-2">
                          <b-button
                            class="pull-right ml-3"
                            style="
                              padding: 0.5rem 0.5rem;
                              font-size: 0.7rem;
                              line-height: 1;
                              border-radius: 0rem;
                              margin-right: 0px;
                            "
                            size="sm"
                            variant="light"
                            @click="getData"
                            >Calculate</b-button
                          >
                          <b-form-input
                            :formatter="capitalizeAll"
                            class="pull-right"
                            style="
                              width: 90px;
                              padding: 10px;
                              background: #f8f9fa;
                              border-radius: 0rem;
                            "
                            v-model="JODRates"
                            id="distance"
                            name="distance"
                            type="number"
                          ></b-form-input>

                          <h6
                            class="card-title font-weight-bold mb-0 ml-2 mt-1"
                          >
                            <small>{{ finalAmountJOD }}</small>
                          </h6>
                        </div>
                        <div class="row mt-2">
                          <b-button
                            class="pull-right ml-3"
                            style="
                              padding: 0.5rem 0.5rem;
                              font-size: 0.7rem;
                              line-height: 1;
                              border-radius: 0rem;
                              margin-right: 0px;
                            "
                            size="sm"
                            variant="light"
                            @click="getData"
                            >Calculate</b-button
                          >
                          <b-form-input
                            :formatter="capitalizeAll"
                            class="pull-right"
                            style="
                              width: 90px;
                              padding: 10px;
                              background: #f8f9fa;
                              border-radius: 0rem;
                            "
                            v-model="AEDRates"
                            id="distance"
                            name="distance"
                            type="number"
                          ></b-form-input>

                          <h6
                            class="card-title font-weight-bold mb-0 ml-2 mt-1"
                          >
                            <small>{{ finalAmountAED }}</small>
                          </h6>
                        </div>
                      </div>
                    </b-collapse>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row gutr">
          <div class="col-md-7 grid-margin stretch-card">
            <div class="card">
              <div class="card-body">
                <h4 class="card-title">Container Type</h4>
                <!-- <p class="card-description text-muted">Frequently Used Top 5</p> -->
                <div id="chart">
                  <apexchart
                    style="margin-top: -20px; margin-left: -25px"
                    v-if="showgraphsAir == true"
                    type="bar"
                    height="300"
                    :options="chartOptionsConBar"
                    :series="seriesConBar"
                  ></apexchart>
                </div>
              </div>
            </div>
          </div>
          <div
            v-if="chartOptionsShipBar.xaxis.categories.length > 0"
            class="col-md-5 grid-margin stretch-card"
          >
            <div class="card">
              <div class="card-body">
                <h4 class="card-title">Shipping Line</h4>
                <p class="card-description text-muted">
                  Top 5 with No.of container Shipped
                </p>
                <div id="chart">
                  <apexchart
                    style="margin-top: -20px; margin-left: -25px"
                    v-if="showgraphsAir == true"
                    type="bar"
                    height="300"
                    :options="chartOptionsShipBar"
                    :series="seriesShipBar"
                  ></apexchart>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row gutr">
          <div
            v-if="topDestinationExportData.length > 0"
            class="col-md-4 grid-margin stretch-card"
          >
            <div class="card">
              <div class="card-body">
                <h4 class="card-title">Export Destination</h4>
                <p class="card-description text-muted">
                  Top 5 with No.of container Shipped
                </p>
                <div class="template-demo">
                  <table class="table mb-0">
                    <tbody>
                      <tr
                        v-for="(item4, index) in topDestinationExportData"
                        :key="index"
                      >
                        <td class="pl-0">{{ item4.exportDesti }}</td>
                        <td class="pr-0 text-right">
                          <b-badge pill variant="primary">{{
                            item4.sumOfContainerExportDestination
                          }}</b-badge>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
          <div
            v-if="topDestinationImportData.length > 0"
            class="col-md-4 grid-margin stretch-card"
          >
            <div class="card topFiveHeight">
              <div class="card-body">
                <h4 class="card-title">Import Destination</h4>
                <p class="card-description text-muted">
                  Top 5 with No.of container Shipped
                </p>
                <div class="template-demo">
                  <table class="table mb-0">
                    <tbody>
                      <tr
                        v-for="(item5, index) in topDestinationImportData"
                        :key="index"
                      >
                        <td class="pl-0">{{ item5.importDesti }}</td>
                        <td class="pr-0 text-right">
                          <b-badge pill variant="primary">{{
                            item5.sumOfContainerImportDestination
                          }}</b-badge>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row gutr">
          <div
            v-if="topCommodityExportData.length > 0"
            class="col-md-6 grid-margin stretch-card"
          >
            <div class="card">
              <div class="card-body">
                <h4 class="card-title">Most Exported Commodity</h4>
                <p class="card-description text-muted">Top 5 (Sea)</p>
                <div class="template-demo">
                  <table class="table mb-0">
                    <!-- <tr>
                      <th></th>
                      <th class="text-right">Container Shipped</th>
                    </tr>-->
                    <tbody>
                      <tr
                        v-for="(item3, index) in topCommodityExportData"
                        :key="index"
                      >
                        <td class="pl-0">{{ item3.commodiExport }}</td>
                        <td class="pr-0 text-right">
                          <b-badge variant="primary">{{
                            item3.totalCountCommodity
                          }}</b-badge>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>

          <div
            v-if="chartOptionsExCom.xaxis.categories.length > 0"
            class="col-md-6 grid-margin stretch-card"
          >
            <div style="height: 340px" class="card">
              <div class="card-body">
                <h4 class="card-title">Most Exported Commodity</h4>
                <p class="card-description text-muted">Top 5 (Sea)</p>
                <div id="chart">
                  <apexchart
                    style="margin-top: -20px; margin-left: -25px"
                    v-if="showgraphsAir == true"
                    type="bar"
                    height="300"
                    :options="chartOptionsExCom"
                    :series="seriesExCom"
                  ></apexchart>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- <div class="row gutr">
          <div class="col-md-6 grid-margin stretch-card">
            <div class="card  topFiveHeight">
              <div class="card-body">
                <h4 class="card-title">Most Imported Commodity</h4>
                <p class="card-description text-muted">Top 5 (Sea)</p>
                <div class="template-demo">
                  <table class="table mb-0">
                    <tbody>
                      <tr>
                        <td class="pl-0">Mask</td>
                        <td class="pr-0 text-right">
                          <b-badge variant="primary">1</b-badge>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>-->
        <div class="row gutr">
          <div
            v-if="chartOptionstopAirline.length > 0"
            class="col-md-4 grid-margin stretch-card"
          >
            <div class="card">
              <div class="card-body">
                <h5 class="card-title">Top 5 Airlines Used</h5>
                <p class="card-description text-muted">Export</p>
                <div id="chart">
                  <apexchart
                    style="margin-top: -30px; margin-left: -25px"
                    v-if="showgraphsAir == true"
                    type="bar"
                    height="240"
                    :options="chartOptionstopAirline"
                    :series="seriestopAirline"
                  ></apexchart>
                </div>
              </div>
            </div>
          </div>
          <div
            v-if="chartOptionsDeparture.length > 0"
            class="col-md-4 grid-margin stretch-card"
          >
            <div class="card">
              <div class="card-body">
                <h4 class="card-title">Top Departure Airports Export</h4>
                <p class="card-description text-muted">
                  Top 5 with No.of Packages Shipped (Air)
                </p>

                <div id="chart55">
                  <apexchart
                    style="margin-top: -30px; margin-left: -25px"
                    v-if="showgraphsAir == true"
                    type="bar"
                    height="240"
                    :options="chartOptionsDeparture"
                    :series="seriesDeparture"
                  ></apexchart>
                </div>
              </div>
            </div>
          </div>

          <div
            v-if="chartOptionsArrive.length > 0"
            class="col-md-4 grid-margin stretch-card"
          >
            <div class="card topFiveHeight">
              <div class="card-body">
                <h4 class="card-title">Top Arrival Airports Import</h4>
                <p class="card-description text-muted">
                  Top 5 No.of Packages (Air)
                </p>
                <div id="chart22">
                  <apexchart
                    style="margin-top: -30px; margin-left: -25px"
                    v-if="showgraphsAir == true"
                    type="bar"
                    height="240"
                    :options="chartOptionsArrive"
                    :series="seriesArrive"
                  ></apexchart>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row gutr"></div>
      </b-card>
    </section>
    <md-dialog-alert
      :md-content="alert.content"
      :md-ok-text="alert.ok"
      ref="addPop22"
    ></md-dialog-alert>
  </div>
</template>

<script>
import { URL_BASE } from "../../../helper/constant.js";
import {
  globalPermissionStatus,
  GlobalGetLocation,
} from "../../../helper/collection";
import DatePicker from "vue2-datepicker";
// import Loading from "vue-loading-overlay";
import CustomLoader from "../../common/customLoader.vue";
import "vue-loading-overlay/dist/vue-loading.css";
import axios from "axios";
import DateRangePicker from "vue2-daterange-picker";
import moment from "moment";
import "vue2-daterange-picker/dist/vue2-daterange-picker.css";

export default {
  beforeMount() {
    this.$store.dispatch("setCurrentRoute", "/dashboard");
    if (
      this.$sessionsStorage.get("loginId") != undefined &&
      this.$sessionsStorage.get("loginId") != "" &&
      this.$sessionsStorage.get("departmentName") != undefined &&
      this.$sessionsStorage.get("departmentName") != "" &&
      this.$sessionsStorage.get("designation") != undefined &&
      this.$sessionsStorage.get("designation") != ""
    ) {
      this.getData();
    } else {
      this.$sessionsStorage.set("loginId", "");
      this.$router.push({
        path: "/Login/",
      });
    }
  },
  mounted() {},

  beforeDestroy() {},
  destroyed() {},
  components: {
    // Loading,
    CustomLoader,
    DatePicker,
    DateRangePicker,
  },
  computed: {},
  data() {
    return {
      startDate: "2017-09-05",
      endDate: "2017-09-15",
      openLeft: "left",
      showCal: false,
      dateRange: { startDate: "2019-09-01", endDate: "2019-09-15" },
      locale: {
        direction: "ltr",
        format: "mm/dd/yyyy",
        separator: " - ",
        applyLabel: "Apply",
        cancelLabel: "Cancel",
        weekLabel: "W",
        customRangeLabel: "Custom Range",
        daysOfWeek: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
        monthNames: [
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "May",
          "Jun",
          "Jul",
          "Aug",
          "Sep",
          "Oct",
          "Nov",
          "Dec",
        ],
        firstDay: 0,
      },
      alert: {
        content:
          this.$sessionsStorage.get("editExportFCLId") != "" &&
          this.$sessionsStorage.get("editExportFCLId") != undefined
            ? "Data Updated Succesfully"
            : "Added Succesfully",
        ok: "ok",
      },
      showgraphsAir: false,
      showgraphsRev: false,
      value1: [new Date(2019, 9, 8), new Date(2019, 9, 19)],
      value2: [],
      langType: {
        pickers: ["Today", "Yesterday", "This Month", "This Year"],
      },
      cunvertUSD: "75",
      calculatGraphRevenue: "75",
      clientName: "",
      companyType: "",
      totalEnq: "",
      totalEnqExistClient: "",
      totalEnqLead: "",
      totalExec: "",
      totalFF: "",
      totalCC: "",
      totalTPT: "",
      totalSeaShipment: "",
      seaShipmentExport: "",
      seaShipmentImport: "",
      totalAirShipment: "",
      airShipmentExport: "",
      airShipmentImport: "",

      totalContainerShiped: "",
      containerShipedExport: "",
      containerShipedImport: "",
      FFfinalAmountUSD: "",
      FFfinalAmountINR: "",
      FFfinalAmountEURO: "",
      FFfinalAmountAED: "",
      FFfinalAmountGBP: "",
      FFfinalAmountZAR: "",
      FFfinalAmountCAD: "",
      FFfinalAmountJOD: "",

      CustomRevenue: "",
      TPTRevenue: "",
      totalRevenueDefaultINR: "",
      finalAmountINR: "",
      finalAmountUSD: "",
      finalAmountAED: "",
      finalAmountEURO: "",
      finalAmountGBP: "",
      finalAmountZAR: "",
      finalAmountCAD: "",
      finalAmountJOD: "",
      AEDRates: 20.42,
      JODRates: 105.75,
      CADRates: 55.21,
      ZARRates: 4.48,
      GBPRates: 94.16,
      EURORates: 85.62,
      USDRates: 74.98,
      backendAmountUSD: "",
      topSlineData: [],
      topContainerData: [],
      topAirlineData: [],
      topCommodityExportData: [],
      topDepartAirPortData: [],
      topArivalAirPortData: [],
      topDestinationExportData: [],
      topDestinationImportData: [],

      isLoading: false,
      series: [],
      chartOptions: {
        plotOptions: {
          pie: {
            // customScale: 1.0
            // size: 200
          },
        },
        chart: {
          width: 200,
          type: "pie",
        },
        labels: [],

        responsive: [
          {
            breakpoint: 480,
            options: {
              chart: {
                width: 200,
              },
              legend: {
                position: "bottom",
              },
            },
          },
        ],
      },

      seriestopAirline: [
        {
          data: [],
        },
      ],
      chartOptionstopAirline: {
        chart: {
          type: "bar",
          height: 380,
          toolbar: {
            show: false,
          },
        },
        plotOptions: {
          bar: {
            barHeight: "100%",
            distributed: true,
            horizontal: true,
            dataLabels: {
              position: "bottom",
            },
          },
        },
        colors: ["#33b2df", "#d4526e"],
        dataLabels: {
          enabled: true,
          textAnchor: "start",
          style: {
            colors: ["#fff"],
          },
          formatter: function (val, opt) {
            return opt.w.globals.labels[opt.dataPointIndex] + ":  " + val;
          },
          offsetX: 0,
          dropShadow: {
            enabled: true,
          },
        },
        stroke: {
          width: 1,
          colors: ["#fff"],
        },
        xaxis: {
          categories: [],
        },
        yaxis: {
          labels: {
            show: false,
          },
        },
        // title: {
        //   text: "Custom DataLabels",
        //   align: "center",
        //   floating: true
        // },
        // subtitle: {
        //   text: "Category Names as DataLabels inside bars",
        //   align: "center"
        // },
        tooltip: {
          theme: "dark",
          x: {
            show: false,
          },
          y: {
            title: {
              formatter: function () {
                return "";
              },
            },
          },
        },
      },

      seriesDeparture: [
        {
          data: [],
        },
      ],
      chartOptionsDeparture: {
        chart: {
          type: "bar",
          height: 380,
          toolbar: {
            show: false,
          },
        },
        plotOptions: {
          bar: {
            barHeight: "100%",
            distributed: true,
            horizontal: true,
            dataLabels: {
              position: "bottom",
            },
          },
        },
        colors: [
          "#33b2df",
          "#546E7A",
          "#d4526e",
          "#13d8aa",
          "#A5978B",
          "#2b908f",
          "#f9a3a4",
          "#90ee7e",
          "#f48024",
          "#69d2e7",
        ],
        dataLabels: {
          enabled: true,
          textAnchor: "start",
          style: {
            colors: ["#fff"],
          },
          formatter: function (val, opt) {
            return opt.w.globals.labels[opt.dataPointIndex] + ":  " + val;
          },
          offsetX: 0,
          dropShadow: {
            enabled: true,
          },
        },
        stroke: {
          width: 1,
          colors: ["#fff"],
        },
        xaxis: {
          categories: [],
        },
        yaxis: {
          labels: {
            show: false,
          },
        },
        // title: {
        //   text: "Custom DataLabels",
        //   align: "center",
        //   floating: true
        // },
        // subtitle: {
        //   text: "Category Names as DataLabels inside bars",
        //   align: "center"
        // },
        tooltip: {
          theme: "dark",
          x: {
            show: false,
          },
          y: {
            title: {
              formatter: function () {
                return "";
              },
            },
          },
        },
      },
      seriesArrive: [
        {
          data: [],
        },
      ],
      chartOptionsArrive: {
        chart: {
          type: "bar",
          height: 380,
          toolbar: {
            show: false,
          },
        },
        plotOptions: {
          bar: {
            barHeight: "100%",
            distributed: true,
            horizontal: true,
            dataLabels: {
              position: "bottom",
            },
          },
        },
        colors: [
          "#33b2df",
          "#546E7A",
          "#d4526e",
          "#13d8aa",
          "#A5978B",
          "#2b908f",
          "#f9a3a4",
          "#90ee7e",
          "#f48024",
          "#69d2e7",
        ],
        dataLabels: {
          enabled: true,
          textAnchor: "start",
          style: {
            colors: ["#fff"],
          },
          formatter: function (val, opt) {
            return opt.w.globals.labels[opt.dataPointIndex] + ":  " + val;
          },
          offsetX: 0,
          dropShadow: {
            enabled: true,
          },
        },
        stroke: {
          width: 1,
          colors: ["#fff"],
        },
        xaxis: {
          categories: [],
        },
        yaxis: {
          labels: {
            show: false,
          },
        },
        // title: {
        //   text: "Custom DataLabels",
        //   align: "center",
        //   floating: true
        // },
        // subtitle: {
        //   text: "Category Names as DataLabels inside bars",
        //   align: "center"
        // },
        tooltip: {
          theme: "dark",
          x: {
            show: false,
          },
          y: {
            title: {
              formatter: function () {
                return "";
              },
            },
          },
        },
      },

      seriesConBar: [
        {
          name: "Export ",
          data: [],
        },
        {
          name: "Import",
          data: [],
        },
      ],

      chartOptionsConBar: {
        chart: {
          type: "bar",
          height: 350,
          stacked: true,
          toolbar: {
            show: false,
          },
          zoom: {
            enabled: true,
          },
        },
        responsive: [
          {
            breakpoint: 480,
            options: {
              legend: {
                position: "bottom",
                offsetX: -10,
                offsetY: 0,
              },
            },
          },
        ],
        plotOptions: {
          bar: {
            horizontal: false,
          },
        },
        xaxis: {
          categories: [],
        },
        legend: {
          position: "bottom",
          offsetY: 10,
        },
        fill: {
          opacity: 1,
        },
      },
      seriesExCom: [
        {
          name: "No.of Times Used",
          data: [],
        },
      ],
      chartOptionsExCom: {
        annotations: {},
        chart: {
          height: 350,
          type: "bar",
          toolbar: {
            show: false,
          },
        },
        plotOptions: {
          bar: {
            columnWidth: "25%",
            endingShape: "rounded",
          },
        },
        dataLabels: {
          enabled: true,
        },
        stroke: {
          width: 2,
        },

        grid: {
          row: {
            colors: ["#fff", "#f2f2f2"],
          },
        },
        xaxis: {
          labels: {
            rotate: -35,
          },
          categories: [],
          tickPlacement: "off",
        },
        yaxis: {
          title: {
            text: "No. of Times Used",
          },
        },
        fill: {
          type: "gradient",
          gradient: {
            shade: "light",
            type: "horizontal",
            shadeIntensity: 0.25,
            gradientToColors: undefined,
            inverseColors: true,
            opacityFrom: 0.85,
            opacityTo: 0.85,
            stops: [50, 0, 100],
          },
        },
      },
      seriesShipBar: [
        {
          name: "No.of Container Shiped",
          data: [],
        },
      ],
      chartOptionsShipBar: {
        annotations: {},
        chart: {
          height: 350,
          type: "bar",
          toolbar: {
            show: false,
          },
        },
        plotOptions: {
          bar: {
            columnWidth: "25%",
            endingShape: "rounded",
          },
        },
        dataLabels: {
          enabled: true,
        },
        stroke: {
          width: 2,
        },

        grid: {
          row: {
            colors: ["#fff", "#f2f2f2"],
          },
        },
        xaxis: {
          labels: {
            rotate: -35,
          },
          categories: [],
          tickPlacement: "on",
        },
        yaxis: {
          title: {
            text: "No. of Container Shipped",
          },
        },
        fill: {
          type: "gradient",
          gradient: {
            shade: "light",
            type: "horizontal",
            shadeIntensity: 0.25,
            gradientToColors: undefined,
            inverseColors: true,
            opacityFrom: 0.85,
            opacityTo: 0.85,
            stops: [50, 0, 100],
          },
        },
      },
    };
  },
  methods: {
    previousPage() {
      window.history.go(-1);
    },
    changeNumberFormat(num) {
      if (num > 9999999) {
        return Math.abs(num) > 9999999
          ? Math.sign(num) * (Math.abs(num) / 10000000).toFixed(2) + " Crore"
          : Math.sign(num) * Math.abs(num);
      } else if (num > 99999) {
        return Math.abs(num) > 99999
          ? Math.sign(num) * (Math.abs(num) / 100000).toFixed(2) + " Lakhs"
          : Math.sign(num) * Math.abs(num);
      } else if (num > 999) {
        return Math.abs(num) > 999
          ? Math.sign(num) * (Math.abs(num) / 1000).toFixed(2) + " Thousand"
          : Math.sign(num) * Math.abs(num);
      } else {
        return num;
      }
    },

    convertCurrency(ID) {
      if (ID == "USD") {
        this.finalAmountUSD =
          parseInt(this.backendAmountUSD) * parseInt(this.cunvertUSD) + " INR";
      }
      if (this.cunvertUSD == "") {
        this.finalAmountUSD = this.backendAmountUSD;
      }
    },
    getData() {
      this.isLoading = true;

      this.chartOptions.labels = [];
      this.topCommodityExportData = [];
      this.series = [];
      this.showgraphsRev = false;
      this.chartOptionsShipBar.xaxis.categories = [];
      this.seriesShipBar[0].data = [];
      let type_Size = {
        clientId: this.$route.params.clientId,
        dateRange: this.dateRange,
      };

      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_EmpDashboard/getSpecificClientReport.php`,
        data: JSON.stringify(type_Size),
        crossDomain: true,

        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };
      axios(options)
        .then((result) => {
          const { statusText, status, data } = result;
          if (status == 200 && data) {
            if (data.msg == "Invalid Token") {
              this.$sessionsStorage.set("loginId", "");
              this.$store.dispatch("setCurrentRoute", "/Login/");
              this.$router.push({
                path: "/Login/",
              });
            } else {
              console.log(data);
              this.clientName = data.clientName;
              this.companyType = data.companyType;
              this.totalEnq = data.totalEnq;
              this.totalEnqExistClient = data.totalEnqExistClient;
              this.totalEnqLead = data.totalEnqLead;
              this.totalExec = data.totalExec;
              this.totalFF = data.totalFF;
              this.totalCC = data.totalCC;
              this.totalTPT = data.totalTPT;
              this.totalSeaShipment = data.totalSeaShipment;
              this.seaShipmentExport = data.seaShipmentExport;
              this.seaShipmentImport = data.seaShipmentImport;
              this.totalAirShipment = data.totalAirShipment;
              this.airShipmentExport = data.airShipmentExport;
              this.airShipmentImport = data.airShipmentImport;

              this.totalContainerShiped = data.totalContainerShiped;
              this.containerShipedExport = data.containerShipedExport;
              this.containerShipedImport = data.containerShipedImport;
              this.CustomRevenue = data.CCfinalAmountINR;
              this.FFfinalAmountUSD = data.FFfinalAmountUSD;
              this.FFfinalAmountINR = data.FFfinalAmountINR;
              this.FFfinalAmountEURO = data.FFfinalAmountEURO;
              this.FFfinalAmountAED = data.FFfinalAmountAED;
              this.FFfinalAmountGBP = data.FFfinalAmountGBP;
              this.FFfinalAmountZAR = data.FFfinalAmountZAR;
              this.FFfinalAmountCAD = data.FFfinalAmountCAD;
              this.FFfinalAmountJOD = data.FFfinalAmountJOD;
              this.TPTRevenue = data.TPTfinalAmountINR;
              this.finalAmountUSD = data.finalAmountUSD;
              this.backendAmountUSD = data.finalAmountUSD;
              this.finalAmountINR = data.finalAmountINR;
              this.finalAmountAED = data.finalAmountAED;
              this.finalAmountEURO = data.finalAmountEURO;
              this.finalAmountGBP = data.finalAmountGBP;
              this.finalAmountZAR = data.finalAmountZAR;
              this.finalAmountCAD = data.finalAmountCAD;
              this.finalAmountJOD = data.finalAmountJOD;

              let TotalRev =
                parseFloat(data.finalAmountINR) +
                parseFloat(this.USDRates) * parseFloat(data.finalAmountUSD) +
                parseFloat(this.AEDRates) * parseFloat(data.finalAmountAED) +
                parseFloat(this.EURORates) * parseFloat(data.finalAmountEURO) +
                parseFloat(this.GBPRates) * parseFloat(data.finalAmountGBP) +
                parseFloat(this.ZARRates) * parseFloat(data.finalAmountZAR) +
                parseFloat(this.CADRates) * parseFloat(data.finalAmountCAD) +
                parseFloat(this.JODRates) * parseFloat(data.finalAmountJOD);

              this.totalRevenueDefaultINR = this.changeNumberFormat(
                parseInt(TotalRev)
              );

              if (data.topDestinationExportData.length > 0) {
                this.topDestinationExportData = data.topDestinationExportData;
              }
              if (data.topDestinationImportData.length > 0) {
                this.topDestinationImportData = data.topDestinationImportData;
              }

              // top Sline Chart
              if (data.topSlineName.length > 0) {
                this.chartOptionsShipBar.xaxis.categories = data.topSlineName;

                this.seriesShipBar[0].data = data.topSlineConCount;
              }

              // client Revenue chart

              // top Container Type chart

              if (data.containerMasterData.length > 0) {
                let conArry = [];
                let conArryIm = [];
                let conTpeArry = [];
                for (let m = 0; m < data.containerMasterData.length; m++) {
                  conTpeArry.push(data.containerMasterData[m].containerType);

                  let conSum = data.topContainerDataEx.filter((x) => {
                    return (
                      x.multipleContainerType ==
                      data.containerMasterData[m].containerType
                    );
                  });

                  if (conSum.length > 0) {
                    const ages = conSum.reduce(
                      (a, { multipleContainerType, multiConNo }) => (
                        (a[multipleContainerType] =
                          (a[multipleContainerType] || 0) + +multiConNo),
                        a
                      ),
                      {}
                    );

                    let abc = Object.values(ages);
                    let pq = abc.toString();
                    conArry.push(parseInt(pq));
                  } else {
                    let noCon = data.containerMasterData[m].containerType;
                    const ages = data.containerMasterData.reduce(
                      (a, { noCon, isContainerTypeActive }) => (
                        (a[noCon] = (a[noCon] || 0) + +0), a
                      ),
                      {}
                    );

                    let abc = Object.values(ages);
                    let pq = abc.toString();
                    conArry.push(parseInt(pq));
                  }

                  let conSumIm = data.topContainerDataIm.filter((x) => {
                    return (
                      x.multipleContainerType ==
                      data.containerMasterData[m].containerType
                    );
                  });
                  if (conSumIm.length > 0) {
                    const agesIm = conSumIm.reduce(
                      (a, { multipleContainerType, multiConNo }) => (
                        (a[multipleContainerType] =
                          (a[multipleContainerType] || 0) + +multiConNo),
                        a
                      ),
                      {}
                    );
                    let abc1 = Object.values(agesIm);
                    let pq1 = abc1.toString();
                    conArryIm.push(parseInt(pq1));
                  } else {
                    let noCon1 = data.containerMasterData[m].containerType;
                    const ages1 = data.containerMasterData.reduce(
                      (a, { noCon1, isContainerTypeActive }) => (
                        (a[noCon1] = (a[noCon1] || 0) + +0), a
                      ),
                      {}
                    );
                    let abc1 = Object.values(ages1);
                    let pq1 = abc1.toString();
                    conArryIm.push(parseInt(pq1));
                  }
                }
                this.chartOptionsConBar.xaxis.categories = conTpeArry;
                this.seriesConBar[0].data = conArry;
                this.seriesConBar[1].data = conArryIm;
              }

              if (data.topCommodityExportData.length > 0) {
                this.topCommodityExportData = data.topCommodityExportData;

                this.chartOptionsExCom.xaxis.categories = data.commodityExport;
                // .push(
                //   this.topCommodityExportData[x].commodityEx.substring(0, 50)
                // );

                this.seriesExCom[0].data = data.commodityCount;
              }

              this.series = data.TotalExecutionChartData;
              for (
                let q = 0;
                q < data.TotalExecutionChartLabelData.length;
                q++
              ) {
                this.chartOptions.labels.push(
                  data.TotalExecutionChartLabelData[q]
                );
              }

              if (data.topAirlineName.length > 0) {
                this.chartOptionstopAirline.xaxis.categories =
                  data.topAirlineName;
                this.seriestopAirline[0].data = data.topAirlineCount;
              }

              if (data.topDepartPort.length > 0) {
                this.chartOptionsDeparture.xaxis.categories =
                  data.topDepartPort;

                this.seriesDeparture[0].data = data.topDepartPortPkg;
              }
              if (data.topArrivePort.length > 0) {
                this.chartOptionsArrive.xaxis.categories = data.topArrivePort;

                this.seriesArrive[0].data = data.topArrivalPortPkg;
              }

              this.showgraphsAir = true;
              this.showgraphsRev = true;

              this.isLoading = false;
            }
          }
        })
        .catch((error) => {});
    },
    dashboardReports() {
      this.$router.push({
        path: "/dashboard/dashboardReports",
      });
      // if (id == "1") {
      //   this.$router.push({
      //     path: "/dashboard/dashboardTptReports"
      //   });
      // } else if (id == "2") {
      //   this.$router.push({
      //     path: "/dashboard/dashboardFfReports"
      //   });
      // } else if ("3") {
      //   this.$router.push({
      //     path: "/dashboard/dashboardCcImpoReports"
      //   });
      // }
    },
    randomValue() {
      this.value = Math.random() * this.max;
    },
  },
};
</script>

<style scoped>
.topFiveHeight {
  height: 305px;
}
.table > thead > tr > th,
.table > tbody > tr > th,
.table > tfoot > tr > th,
.table > thead > tr > td,
.table > tbody > tr > td,
.table > tfoot > tr > td {
  border-top: 1px solid #ffffff !important;
}
.mainCard {
  display: flex;
  margin-bottom: 2rem;
  justify-content: space-between;
  padding: 0;
  border-radius: 10px;
  position: relative;
  min-height: 50px;
  border-bottom: 1px solid #eee !important;
}
.card-header {
  padding: 0.75rem 1.25rem;
  margin-bottom: 0;
  background-color: rgba(0, 0, 0, 0.03);
  border-bottom: none !important;
}
.page-header {
  display: flex;
  align-items: center;
  margin: 1.5rem 2rem 1.5rem;
  justify-content: space-between;
  padding: 0;
  border-radius: 3px;
  position: relative;
  min-height: 50px;
  border-bottom: 1px solid #eee !important;
}
.page-title {
  margin: 0;
  font-size: 25px;
  font-weight: 600;
  line-height: 2.5rem;
  position: relative;
  color: #2f2752;
}
.subpage-title {
  font-weight: 300;
  color: #43377b;
}

.dropdown-item {
  display: block;
  width: 100%;
  padding: 0.25rem 1.5rem;
  clear: both;
  font-weight: 400;
  color: #212529;
  text-align: inherit;
  white-space: nowrap;
  background-color: transparent;
  border: 0;
}

.topDivCard {
  margin: 1.5rem 2rem 1.5rem;

  position: relative;

  display: flex;

  flex-direction: column;
  min-width: 0;
  word-wrap: break-word;
  background-color: #fff;
  background-clip: border-box;
  box-shadow: -8px 12px 18px 0 rgba(25, 42, 70, 0.13);
  border-radius: 3px;
  border: 1px solid transparent;
  margin-bottom: 1.5rem;
  width: 100%;
}
.mb-3 {
  margin: 1.5rem 1rem 1.5rem;
  margin-bottom: 0rem !important;
  font-weight: 600 !important;
  color: #2f2752;
}
.mb-2 {
  margin-bottom: 0 !important;
  font-weight: 700 !important;
}
.mb-4 {
  margin-bottom: -0.5rem !important;
  font-weight: 700 !important;
}
.col-lg-6 {
  width: 49%;
}
.col-lg-4 {
  width: 32.6%;
}
</style>



// WEBPACK FOOTER //
// specificClientReports.vue?18887166